import { createFileRoute } from '@tanstack/react-router';
import { scansListOptions, toScansQuery } from '@/features/scans/api';
import { ScansPage } from '@/features/scans/ScansPage';
import { marketsQueryOptions, readStoredMarket, resolveMarketId } from '@/lib/market';
import { SCANS_SEARCH_DEFAULTS, ScansSearch, stripDefaults } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/scans/')({
  validateSearch: ScansSearch,
  search: { middlewares: [stripDefaults(ScansSearch, SCANS_SEARCH_DEFAULTS)] },
  loaderDeps: ({ search }) => search,
  // Préchargement : les erreurs sont laissées à `useQuery` dans la page (`ErrorState` avec « Réessayer »).
  loader: async ({ context, deps }) => {
    const markets = await context.queryClient
      .ensureQueryData(marketsQueryOptions())
      .catch(() => undefined);
    const marketId = resolveMarketId({
      fromSearch: deps.market,
      stored: readStoredMarket(),
      markets,
    });
    if (!marketId) return;
    await context.queryClient
      .ensureQueryData(scansListOptions(toScansQuery(deps, marketId)))
      .catch(() => undefined);
  },
  component: ScansPage,
});
